export const money = (v) => {
  const n = Number(v);
  if (isNaN(n)) return "$0";
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
};

export const numFmt = (v) => {
  const n = Number(v);
  if (isNaN(n)) return "0";
  return n.toLocaleString("en-US");
};

export const dateFmt = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso;
  }
};
